export const INITIALISED = 'INITIALISED';
export const REQUESTING_VALIDATION = 'REQUESTING_VALIDATION';
export const REQUESTING_SESSION_VALIDATION = 'REQUESTING_SESSION_VALIDATION';
export const REQUESTING_LOGIN = 'REQUESTING_LOGIN';
export const REQUESTING_LOGIN_CODE = 'REQUESTING_LOGIN_CODE';
export const REQUESTING_LOGOUT = 'REQUESTING_LOGOUT';
export const LOGGED_IN = 'LOGGED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';
export const LOGIN_REQUIRED = 'LOGIN_REQUIRED';
export const LOGIN_CODE_REQUIRED = 'LOGIN_CODE_REQUIRED';
export const LOGIN_CODE_SETUP_REQUIRED = 'LOGIN_CODE_SETUP_REQUIRED';
export const SESSION_TIMEOUT = 'SESSION_TIMEOUT';
export const SESSION_EXPIRED_MESSAGE = 'SURL failed validation';
export const SESSION_RELOGIN_MESSAGE = 'Please log in again';
export const SESSION_CODE_REQUIRED_MESSAGE = 'Please insert authentication code';
export const SESSION_CODE_INVALID_MESSAGE = 'Invalid code. Please log in again';

